<template>
    <div v-if="form.errors.any()" class="rounded-md bg-red-50 p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"></path></svg>
            </div>
            <div class="ml-3">
                <div v-if="!form.errors.has('error')">
                    <h3 class="text-sm font-medium text-red-800">
                        <span v-if="form.errors.count() == 1">There's 1 error in your submission</span>
                        <span v-else>There are {{ form.errors.count() }} errors in your submission</span>
                    </h3>
                    <div class="mt-2 text-sm text-red-700">
                        <ul class="list-disc pl-5 space-y-1">
                            <li v-for="(error, index) in form.errors.flatten()" :key="index">
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else>
                    <h3 class="text-sm font-medium text-red-800">
                        {{ form.errors.only('error')[0] }}
                    </h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        form: {
            type: Object,
            required: true
        }
    }
}
</script>

<style>

</style>
